import script from "./Legal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Legal.vue?vue&type=script&lang=ts&setup=true"

import "./Legal.vue?vue&type=style&index=0&id=0b9f2de4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9f2de4"]])

export default __exports__